import { createSlice } from "@reduxjs/toolkit";

const indicationsDashboardFiltersSlice = createSlice({
  name: "indicationsDashboardFilters",
  initialState: {
    providerIds: [],
  },
  reducers: {
    setVendorsFilters: (state, action) => {
      state.providerIds = action.payload.providerIds || state.providerIds;
    },
  },
});

export const {
  setVendorsFilters,
} = indicationsDashboardFiltersSlice.actions;
export default indicationsDashboardFiltersSlice.reducer;
